// A Today appointment's status as the one soft status chip (design 21-10, EncounterStatusChip: "there is no glyph-only
// variant"), on the DS StatusChip. The label is the PA's own status word (the API display, or Unsigned / Triaged); the
// colour follows the glyph kind the row already computes (appointment-glyph.ts). `data-glyph-text` keeps the kind on
// the wrapper for the row's own hooks.
import { StatusChip } from '@scripsteam/scrips-signal-ds';
import type { ReactNode } from 'react';
import type { GlyphKind } from '@/shared/ui/components/status-glyph-tokens';
import { chipSemanticForGlyph } from '../lib/appointment-glyph';

export function TodayStatusChip({ kind, children }: { kind: GlyphKind; children: ReactNode }) {
  return (
    <span data-glyph-text={kind} className="inline-flex">
      <StatusChip semantic={chipSemanticForGlyph(kind)}>{children}</StatusChip>
    </span>
  );
}
